module.exports = __webpack_public_path__ + "ota-icons.0315db408f564fb9e09c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-icons/fonts/ota-icons.ttf?xst5zg
// module id = 1377
// module chunks = 24